import { initIntersectionObserver, ReviewLinesLimiter, addToGlobalThisRet } from "@plugins";
import Swiper from "swiper";
import jquery from "jquery";

const $ = jquery;

$(document).ajaxSuccess(() => initReviewPhotosSliders());

window.addEventListener("load", () => {
    initLinesLimiter();
    initReviewPhotosSliders();
});

function initLinesLimiter() {
    if (window.mobileMedia) {
        const reviews = document.querySelectorAll(".js-reviews-line-limiter-init");

        if (reviews && reviews.length > 0) {
            for (let review of reviews) {
                review = new ReviewLinesLimiter(review);
            }
        }
    }
}

function initReviewPhotosSliders() {
    const reviewPhotosSliders = document.querySelectorAll(".js-review-slider");

    if (reviewPhotosSliders) {
        for (const slider of reviewPhotosSliders) {
            if (!slider.dataset.activated) {
                initIntersectionObserver(slider, initPhotosSlider);
            }
        }
    }
}

function initPhotosSlider(slider) {
    new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 8,
        watchOverflow: true,
    });

    slider.setAttribute("data-activated", true);
}

addToGlobalThisRet(initLinesLimiter, "initReviewsLineLimiter");
